import { db } from "../firebase/firebaseConfig";
import { useEffect, useState } from "react";
import {doc, getDoc} from "firebase/firestore";
import { useNavigate } from "react-router-dom";



const useObtenerClientesPorId = (id) => {
    const [clientesPorID, setClientesPorId]=useState([]);
    const navigate=useNavigate();
   
    useEffect(()=>{
        
        if (id!=='') {
            const clientesPorID=async()=>{
                const documento= await getDoc(doc(db,'clientes',id));
                if (documento.exists) {
                    setClientesPorId(documento)
                } else {
                    navigate('/clientes');
                }
                
            }
            clientesPorID();
        } 
        },[id,navigate])
        
    return [clientesPorID];
}
 
export default useObtenerClientesPorId;